import Alpine from "alpinejs";

Alpine.data("loadingButton", () => ({
  init() {
    const loadingIcon = this.$el.querySelector(".icon-loading");
    loadingIcon.classList.remove("hidden");
    loadingIcon.setAttribute("x-show", "loading");
    this.$refs.label.setAttribute("x-show", "!loading");
    this.$el.setAttribute("x-cloak", "true");
  },
}));
